import { createAsyncThunk } from '@reduxjs/toolkit';
import BulkEditService from 'services/bulk_edit/bulkEdit.service';
import { setFilters, setPage, setSort } from './bulkEditIndex';
import { REJECT_ERROR } from './constants';

export const fetchBulkVehicles = createAsyncThunk(
	'bulkEditIndex/fetchBulkVehicles',
	async (_, { getState, rejectWithValue }) => {
		const {
			bulkEditIndex: { query },
		} = getState();

		try {
			const { data: response } = await BulkEditService.instance.getBulkVehicles(query);
			const { success, data: bulkVehicles = [], metadata } = response || {};

			if (!success) {
				return rejectWithValue(REJECT_ERROR);
			}

			return { bulkVehicles, metadata };
		} catch (error) {
			return rejectWithValue(error?.message || REJECT_ERROR);
		}
	},
);

export const fetchBulkVehiclesMetadata = createAsyncThunk(
	'bulkEditIndex/fetchBulkVehiclesMetadata',
	async (_, { getState, rejectWithValue }) => {
		const {
			bulkEditIndex: { query },
		} = getState();

		try {
			const { data: response } = await BulkEditService.instance.getBulkVehiclesMetadata(query);
			const { success, metadata } = response || {};

			if (!success) return rejectWithValue(REJECT_ERROR);

			return { metadata };
		} catch (error) {
			return rejectWithValue(error?.message || REJECT_ERROR);
		}
	},
);

export const refetchBulkVehicles = () => async (dispatch) => {
	return dispatch(fetchBulkVehicles());
};

export const updateFiltersAndFetch = (newFilters) => async (dispatch) => {
	dispatch(setFilters(newFilters));
	return dispatch(refetchBulkVehicles());
};

export const updateSortingAndFetch = (newSorting) => async (dispatch) => {
	dispatch(setSort(newSorting));
	return dispatch(refetchBulkVehicles());
};

export const updatePageAndFetch = (page) => async (dispatch) => {
	dispatch(setPage(page));
	return dispatch(refetchBulkVehicles());
};
